import { getDriftToken } from 'services/tokenService'
import { createAxiosInstance } from 'api/axiosFactory'
import config from 'config'


const axiosInstance = () => {
  const axiosConfig = {
    baseURL: config.CUSTOMER_API_URL,
    headers: {'Authorization': `Bearer ${getDriftToken()}`}
  }
  return createAxiosInstance(axiosConfig)
}

export const authorizeApp = (id, state, redirect_uri) => {
  const stateParam = !!state ? `state=${state}&` : ""
  const redirectParam = !!redirect_uri ? `redirect_uri=${redirect_uri}` : ""
  return axiosInstance().post(`/integrations/external/${id}/authorize?${stateParam}${redirectParam}`)
    .then(response => response.data)
}

export const fetchAppWithScopesByClient = (client_id) =>
  axiosInstance().get(`/integrations/external/client/${client_id}`)
    .then(response => response.data)
